import { FormGroup, FormControl } from '@angular/forms';
import { CommonListData, NavigateRoutes, TRANSACTION_MODE, TRANSACTION_TYPE, TransactionStatus } from 'common/constants/app.constant';
import { BHMetaSelectModel, BaseDataModel } from 'common/models/utilitymodels/base.model';
import { HeadersList, ListMetaModel, ListModel, QueryParams } from 'common/models/utilitymodels/list.model';

export class StopTransactionApiQueryParams {
    FLAG: string = 'GETMAPPEDSYSDETAILS';
    SCHEME: string = '';
    FOLIO: string = '';
    TYPE: string = '';
    USER_ID: string = '';
    SESSION_ID: string = '';
    SESSION_VALIDATE: string = 'N';
    BROK_DLR_CODE: string = '';
}

export class StopTransactionPostParams {
    FLAG: string = 'STOPTRANS_DISTRIBUTOR';
    FOLIO: string = '';
    TRXN_TYPE: string = '';
    SCHEME_NAME: string = '';
    SCHEME_CODE: string = '';
    REF_NO: string = '';
    AMOUNT: string = '';
    FREQUENCY: string = '';
    START_DATE: string = '';
    END_DATE: string = '';
    BANK_NAME: string = '';
    TRG_USER_NAME: string = '';
    TRG_MOBILE_NUMBER: string = '';
    URL_TYPE: string = 'TRANS-TRIGGER';
    PAY_MECH: string = '';
    DESTINATION_SCHEME_NAME: string = '';
    USER_TRXN_NO: number = 0;
    TRANSACTION_REF_NO: string = '';
    INVESTOR_FIRST_NAME: string = '';
    BROK_DLR_CODE: string = '';
}

export class StopTransactionDataModel extends BaseDataModel {
    'FOLIO_NO': string = '3534638';
    'SCHEMENAME': string = 'Ktk MultiAssetAllocFOFDyn Gr-D';
    'AMOUNT': number = 100;
    'UNITS': number = 0;
    'FREQUENCY': string = 'Once a Month';
    'STARTDATE': string = '27-Nov-2023';
    'ENDDATE': string = '27-Oct-2028';
    'URN': string = 'KTDIRECT-505969';
    'REGISTN_STATUS': string = '';
    'SCHEME_CODE': string = '107D';
    'REQUEST_REF_NO': string = 'KTDIRECT-505969';
    'USER_TRXNNO': number = 12276374;
    'AUTO_TRXN_TYPE': string = 'P';
    'STATUS': string = 'Pending';
    'ISIP_STATUS': string = 'P';
    'PAYMENT_MECHANISM': string = 'ISIP';
    'UMRN': null;
    transactionType: string = '';
}

export class StopTransactionListingModel extends ListModel<StopTransactionDataModel> { }

export class StopTransactionMetaModel extends ListMetaModel<HeadersList> {
    transactionStatus = TransactionStatus;
    showModal: boolean = false;
    constructor() {
        super('STOP TRANSACTION', '', true, CommonListData.rowPerPage, NavigateRoutes.selectInvestor);
    }

    prepareHeaderList(): HeadersList[] {
        const headers: HeadersList[] = [];
        const name = new HeadersList('Scheme Name', 'SCHEMENAME', true, true, 'text');
        const AMOUNT = new HeadersList('amount', 'AMOUNT', false, true, 'number');
        const FREQUENCY = new HeadersList('Frequency', 'FREQUENCY', true, true, 'text');
        const STARTDATE = new HeadersList('Start Date', 'STARTDATE', true, true, 'text');
        const ENDDATE = new HeadersList('End Date', 'ENDDATE', true, true, 'text');
        const STATUS = new HeadersList('Status', 'STATUS', true, true, 'text');
        const URN = new HeadersList('URN', 'URN', true, true, 'text');

        headers.push(name);
        headers.push(AMOUNT);
        headers.push(FREQUENCY);
        headers.push(STARTDATE);
        headers.push(ENDDATE);
        headers.push(STATUS);
        headers.push(URN);

        return headers;
    }

    initProperties(): any {
        const dataInfo = {
            isEditable: this.isEditable,
            recordPerPage: this.recordPerPage,
            listInfo: this.prepareHeaderList(),
            pointer: undefined,
            isSortOpen: false,
            isFilterOpen: false,
            transactionType: new BHMetaSelectModel('transactionType', 'transactionType', true, 'Transaction Type', 'select', 'Select Transaction Type', TRANSACTION_TYPE, 'name', 'id', false),
            transactionMode: new BHMetaSelectModel('transactionMode', 'transactionMode', true, 'Transaction Mode', 'select', 'Select Transaction Mode', TRANSACTION_MODE, 'name', 'id', false),
            showModal: this.showModal,
        };
        return dataInfo;
    }
}

export class StopTransactionListingParams extends QueryParams {
    transactionModeFilter: string = '';
    folio: string = '';
    brokerCode: string = '';
}
